<template>
	<div class="popup">

        <div class="popup-header">
            <div>
                 {{ $t("labels.confirm") }}
            </div>
            <div  class="popup-close" @click="$emit('close')">
                <font-awesome-icon icon="times" />
            </div>
        </div>
        <div class="popup-body" style="overflow:hidden">
          <b-container>
          <div class="row" v-if="user_id!=-1">
            <div class="col-3">{{$t('labels.user')}}</div>
            <div class="col">{{ username_by_id(user_id) }}</div>
          </div>
          <div class="row" v-else>
            <div class="col-3">{{$t('labels.user')}}</div>
            <div class="col">
              <v-select :options="this.availablezzpers()" v-model="to" @input="changeUserID()">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                                <font-awesome-icon style=" margin-right: 1rem;float:right;color:lightgreen" v-if="option.waxes.length==0" icon="circle" />
                                <font-awesome-icon style=" margin-right: 1rem;float:right;color:orange" v-if="option.waxes.length==1" icon="circle" />
                                <font-awesome-icon style=" margin-right: 1rem;float:right;color:red" v-if="option.waxes.length>1" icon="circle" />
                
                            </template>
                            </v-select>


            </div>
          </div>
          <div class="row">
            <div class="col-3">{{$t('labels.project')}}</div>
            <div class="col">{{ project_by_id(project_id).title }}</div>
          </div>
          <div class="row">
            <div class="col">{{$t('labels.startdate')}} </div>
            <div class="col"><input type="date" v-model='initstart'></div>
            <div class="col">{{$t('labels.enddate')}}</div>
            <div class="col"><input type="date" v-model='initend'></div>
          </div>
          <div class="row">
            <div class="col">{{$t('meta.starttijd')}}</div>
            <div class="col"><input type="time" v-model='initstartt'></div>
            <div class="col">{{$t('meta.eindtijd')}}</div>
            <div class="col"><input type="time" v-model='initendt'></div>
          </div>     
          <div  class = "row" v-for="(res, idx) in user_resource" :key="res+idx">
            <div class="col-2">{{$t('labels.resource')}}</div>
            <div class="col-5"><b-form-checkbox  v-model="resourcecheck[res.id]">{{$t('labels.planresource')}}</b-form-checkbox></div>
            <div class="col-5">{{ res.name }} - {{ res.identification }}</div>  
          </div>   
          <checkuserplan :user_id="user_id" :startdate="initstart" :enddate="initend" />

          </b-container>
        </div>
        <div class="popup-footer">
            <div class="btn btn-primary" @click="changeID()" v-if="changedID">{{ $t('buttons.otheruser') }}</div>
            <div class="btn btn-primary" @click="$emit('close')">{{ $t("buttons.cancel") }}</div>
            <div @click="save_and_close" class="btn btn-primary">{{ $t("buttons.saveandclose") }}</div>
        </div>
    </div>
</template>

<script>
import {  mapGetters, mapState, mapActions} from 'vuex'
import checkuserplan from './CheckUserPlanning.vue';

export default {
    name: 'dropuseronproject-modal',
    data() {
        return {
          confirmed:false,
          initstart:null,
          initend:null,
          initstartt:null,
          initendt:null,          
          resource_id:null,
          resourcecheck:[],
          to:null,
          changedID:false
        }
    },
    props: {
        project_id:Number,
        user_id: Number
    },
    mounted() {
        this.$store.commit('modal_confirm',{ id: 0})
        this.initstart = this.project.startdate
        this.initend = this.project.enddate
        this.initstartt = this.project.starttime
        this.initendt = this.project.endtime
    },
    computed: {
      ...mapGetters ([
      'zzpers',
      'project_by_id',
      'user_by_id',
      'username_by_id',
       'createAny'

    ]),
    ...mapState ([
      'ffwax',
      'resources',
      ''

    ]), 
    project(){
      return this.project_by_id(this.project_id)
    },    
    start_offset(){
      return Math.round(( new Date(this.initstart).getTime() - new Date(this.project.startdate).getTime())/86400000)
    },
    end_offset() {
      return Math.round(( new Date(this.initend).getTime() - new Date(this.initstart).getTime())/86400000)

    },
    user_resource(){
      return this.resources.filter(r=>r.user_id==this.user_id)
    },
    },
    methods: {
      ...mapActions([
      'add_ffwax'
    ]),      
        save_and_close() {
          let tosave = this.user_id
          if(tosave==-1){
            tosave = this.to.id
          }
          let ffwax = {id:0, user_id:tosave,project_id:this.project_id, resource_id:null, start_offset:this.start_offset,end_offset:this.end_offset, start_time:this.initstartt,end_time:this.initendt}
          this.add_ffwax(ffwax)
          for(var i=0; i<this.user_resource.length;i++){
            if(this.resourcecheck[this.user_resource[i].id]==true){
              console.log("plan in ",this.user_resource[i].name)
              let ffwax = {id:0, user_id:null,project_id:this.project_id, resource_id:this.user_resource[i].id, start_offset:this.start_offset,end_offset:this.end_offset, start_time:this.initstartt,end_time:this.initendt}
              this.add_ffwax(ffwax)
            }

          }
          this.$emit('close')
        },
        availablezzpers() {
            let persons = []
            this.zzpers.map(item=>item.id).forEach(aperson => {
              if(this.ffwax.filter(f=> f.user_id==aperson && f.project_id==this.project_id).length==0)
                persons.push({ id: aperson, label: this.username_by_id(aperson), 
                waxes:this.waxes(aperson)
              })
            });    
            return persons

          },  
          waxes(u) {
            return this.ffwax.filter(f => f.user_id == u)
            .filter(ff => {
              let gendday = new Date(this.initstart)
              let startday = new Date(this.initend)
              var startdate
              if(ff.project_id>9990000){
                let year = ff.project_id - 9990000
                startdate = new Date(Date.UTC(year, 0, 1))
              } else {
                startdate = new Date(this.project_by_id(ff.project_id).startdate)
              }
              // let startdate = new Date(this.project_by_id(ff.project_id).startdate)
              startdate.setDate(startdate.getDate() + ff.start_offset);
              let enddate = new Date(startdate)
              enddate.setDate(enddate.getDate() + ff.end_offset);
              return this.dateRangeOverlaps(startday, gendday, startdate, enddate)

            })
        
          },   
          changeUserID(){
            // eslint-disable-next-line vue/no-mutating-props
            this.user_id=this.to.id
            this.changedID = true
            console.log(this.user_id)
          },
          changeID(){
            this.changedID = false
            // eslint-disable-next-line vue/no-mutating-props
            this.user_id=-1
          }

    },

    components :{checkuserplan}

}
</script>